/* eslint-disable react/no-children-prop */
import { Spinner } from 'reactstrap';
import EventRangePickers from './eventRangePickers';
import useChangeEventDuration from './useChangeEventDuration';
import './styles.scss';

export type ChangeEventDurationProps = {
  onCancel: () => void;
  timezone?: any;
  timezoneOffset: number;
  ecgDataMap: any;
  studyId: string;
  profileId: string;
  selectedEvent: any;
};

/**
 * Renders the draggable modal for editing a selected event's start and end times. Delegates state and handlers to useChangeEventDuration, embeds the range pickers with their per-field errors, and swaps the Done label for a spinner while the save is in flight.
 *
 * @param props - Modal props forwarded to the change-duration hook.
 * @returns The rendered change-duration modal body with its cancel and done buttons.
 */
const ChangeEventDuration = ({
  onCancel,
  timezone,
  timezoneOffset,
  ecgDataMap,
  studyId,
  profileId,
  selectedEvent,
}: ChangeEventDurationProps) => {
  const { state, onChange, onClickCancel, onClickSave } = useChangeEventDuration({
    onCancel,
    timezone,
    timezoneOffset,
    ecgDataMap,
    studyId,
    profileId,
    selectedEvent,
  });

  return (
    <>
      <div className="draggable-modal-content">
        <div className="content-title">Change event duration</div>
        <div className="content">
          <EventRangePickers
            startDate={state.startDate}
            endDate={state.endDate}
            startTime={state.startTime}
            endTime={state.endTime}
            onChangePicker={onChange}
            error={state.errorObject}
          />
        </div>
      </div>
      <div className="footer-btn">
        <button id="cancel-change-duration" className="draggable-modal-btn" onClick={onClickCancel}>
          Cancel
        </button>
        <button
          id="done-change-duration"
          className="draggable-modal-btn btn-main"
          onClick={onClickSave}
        >
          {state.isSaving ? <Spinner children="" /> : 'Done'}
        </button>
      </div>
    </>
  );
};

export default ChangeEventDuration;
